module.exports = __webpack_public_path__ + "img/20191218154953868.5ce27ac1.jpg";